export default __webpack_public_path__ + "static/media/artist_grady.e46758ac.jpg";